import { useTranslation } from 'react-i18next'

import { useScreen } from '../../../../../hooks'
import { FormikField } from '../../../../Formik'
import { InputField } from '../../../../Input'
import {
  BUILDING_FORM_BUILDING_NUMBER_FIELD_MAX_LENGTH,
  BUILDING_FORM_FIELD_NAME_BUILDING_NUMBER,
} from '../../BuildingForm.constants'

function BuildingNumberField() {
  const { t } = useTranslation()

  const { isMobileScreenSize } = useScreen() // TODO make same by css media instead of useScreen

  return (
    <FormikField
      hasCounter
      Component={InputField}
      borderless={!isMobileScreenSize}
      fieldComponentProps={{
        label: `${t('Building.NumberLabelKey')}:`,
        shouldAdaptToMobileScreen: true,
      }}
      inline={isMobileScreenSize}
      maxLength={BUILDING_FORM_BUILDING_NUMBER_FIELD_MAX_LENGTH}
      name={BUILDING_FORM_FIELD_NAME_BUILDING_NUMBER}
      placeholder={t('Building.NumberPlaceholderKey')}
    />
  )
}

export default BuildingNumberField
